export type ChangeCategory = 'added' | 'improved' | 'fixed'

export interface ChangelogItem {
  readonly key: string
  readonly category: ChangeCategory
}

export interface ChangelogRelease {
  readonly id: string
  readonly date: string
  readonly emoji?: string
  readonly summaryKey?: string
  readonly items: readonly ChangelogItem[]
}

// Prepend releases with a new, permanent ID; editing copy does not announce again.
export const changelogReleases: readonly ChangelogRelease[] = [
  {
    id: 'update20260918',
    date: '2026-09-18',
    items: [
      { key: 'rankPageRebuild', category: 'added' },
      { key: 'browserCompatibility', category: 'improved' },
      { key: 'captureTimeout', category: 'improved' },
    ],
  },
  {
    id: 'update20260914',
    date: '2026-09-14',
    items: [
      { key: 'realtimeExpRate', category: 'added' },
      { key: 'firstUseAutoLocate', category: 'added' },
      { key: 'clearerMetrics', category: 'improved' },
    ],
  },
  {
    id: 'update20260913',
    date: '2026-09-13',
    items: [
      { key: 'autoLocateMesos', category: 'added' },
      { key: 'factoryReset', category: 'added' },
      { key: 'pipWindowSize', category: 'added' },
      { key: 'calibrationPreview', category: 'improved' },
      { key: 'recoveryPaths', category: 'improved' },
      { key: 'highDpiRecognition', category: 'fixed' },
      { key: 'upgradeExpAccounting', category: 'fixed' },
    ],
  },
  {
    id: 'update20260910',
    date: '2026-09-10',
    items: [
      { key: 'newLayoutAutoLocate', category: 'added' },
      { key: 'rankMapTip', category: 'added' },
      { key: 'calibrationSimpler', category: 'improved' },
      { key: 'jobLineRecognition', category: 'improved' },
    ],
  },
  {
    id: 'update20260909',
    date: '2026-09-09',
    items: [
      { key: 'recognitionPerformance', category: 'added' },
      { key: 'hpMpRates', category: 'improved' },
      { key: 'lowFrequencyMesos', category: 'improved' },
      { key: 'mapRomanSuffix', category: 'fixed' },
    ],
  },
  {
    id: 'update20260908',
    date: '2026-09-08',
    items: [
      { key: 'streamSkins', category: 'added' },
      { key: 'streamConnect', category: 'added' },
      { key: 'allLevelRankings', category: 'added' },
      { key: 'localDiagnostics', category: 'added' },
      { key: 'screenCaptureFallback', category: 'improved' },
      { key: 'recognitionRecovery', category: 'improved' },
      { key: 'captureFailureGuidance', category: 'fixed' },
      { key: 'jobRecognition', category: 'fixed' },
    ],
  },
  {
    id: 'update20260907',
    date: '2026-09-07',
    items: [
      { key: 'mapRanking', category: 'added' },
      { key: 'widgetSkins', category: 'added' },
      { key: 'efficiencyChart', category: 'added' },
      { key: 'calibrationExamples', category: 'added' },
      { key: 'autoRegion', category: 'improved' },
      { key: 'recognitionPerformance', category: 'improved' },
      { key: 'startFeedback', category: 'improved' },
      { key: 'responsiveWidget', category: 'improved' },
      { key: 'firefoxCompatibility', category: 'fixed' },
      { key: 'recordingStart', category: 'fixed' },
    ],
  },
  {
    id: 'update20260904',
    date: '2026-09-04',
    emoji: '✨',
    items: [
      { key: 'efficiencyTrend', category: 'added' },
      { key: 'expRate', category: 'improved' },
      { key: 'startupSpeed', category: 'improved' },
      { key: 'windowSelection', category: 'improved' },
      { key: 'mesosAccuracy', category: 'fixed' },
    ],
  },
  {
    id: 'launch20260902',
    date: '2026-09-02',
    emoji: '🍁',
    summaryKey: 'changelog.releases.launch20260902.summary',
    items: [],
  },
]

export const latestRelease = changelogReleases[0]

export function formatReleaseDate(value: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC',
  }).format(new Date(`${value}T00:00:00Z`))
}
